"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
/**
 * @swagger
 * definitions:
 *   TransactionStatus:
 *     type: string
 *     enum:
 *      - pending
 *      - completed
 *      - processing
 */
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["PENDING"] = "pending";
    TransactionStatus["COMPLETED"] = "completed";
    TransactionStatus["CANCELLED"] = "cancelled";
    TransactionStatus["PROCESSING"] = "processing";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
function parseTransactionsById(paymentTypeId, transactions) {
    return transactions.filter(function (transaction) { return transaction.paymentTypeId === paymentTypeId; });
}
exports.parseTransactionsById = parseTransactionsById;
function parseTransactionsWithoutId(paymentTypeId, transactions) {
    return transactions.filter(function (transaction) { return transaction.paymentTypeId !== paymentTypeId; });
}
exports.parseTransactionsWithoutId = parseTransactionsWithoutId;
function parseTotalTransactionsById(paymentTypeId, transactions) {
    var parsedTransactionTypes = parseTransactionsById(paymentTypeId, transactions);
    var total = parsedTransactionTypes.reduce(function (acc, cur) { return acc + cur.amount; }, 0);
    return total;
}
exports.parseTotalTransactionsById = parseTotalTransactionsById;
/**
 * @swagger
 * definitions:
 *   PaymentTypeIds:
 *     type: number
 *     enum:
 *      - 1
 *      - 2
 *      - 3
 *      - 4
 *      - 5
 *      - 6
 *      - 7
 *      - 8
 *      - 9
 *      - 10
 *      - 11
 *      - 12
 *      - 13
 *      - 14
 */
var PaymentTypeIds;
(function (PaymentTypeIds) {
    PaymentTypeIds[PaymentTypeIds["cash"] = 1] = "cash";
    PaymentTypeIds[PaymentTypeIds["credit"] = 2] = "credit";
    PaymentTypeIds[PaymentTypeIds["debit"] = 3] = "debit";
    PaymentTypeIds[PaymentTypeIds["other"] = 4] = "other";
    PaymentTypeIds[PaymentTypeIds["merrco"] = 5] = "merrco";
    PaymentTypeIds[PaymentTypeIds["global"] = 6] = "global";
    PaymentTypeIds[PaymentTypeIds["moneris"] = 7] = "moneris";
    PaymentTypeIds[PaymentTypeIds["etransfer"] = 8] = "etransfer";
    PaymentTypeIds[PaymentTypeIds["merrcoDataCandy"] = 9] = "merrcoDataCandy";
    PaymentTypeIds[PaymentTypeIds["online"] = 10] = "online";
    PaymentTypeIds[PaymentTypeIds["birchmount"] = 11] = "birchmount";
    PaymentTypeIds[PaymentTypeIds["worldpay"] = 12] = "worldpay";
    PaymentTypeIds[PaymentTypeIds["loyalty"] = 13] = "loyalty";
    PaymentTypeIds[PaymentTypeIds["blazepay"] = 14] = "blazepay";
})(PaymentTypeIds = exports.PaymentTypeIds || (exports.PaymentTypeIds = {}));
// When PaymentTypeIds is updated, this needs to be updated as well
// homi-api:
//   - src/api/repositories/ShiftRepository.ts
exports.convertPaymentTypeIdToName = function (paymentTypeId) {
    switch (paymentTypeId) {
        case PaymentTypeIds.cash:
            return 'Cash';
        case PaymentTypeIds.credit:
            return 'Credit';
        case PaymentTypeIds.debit:
            return 'Debit';
        case PaymentTypeIds.other:
            return 'Other';
        case PaymentTypeIds.merrco:
            return 'Merrco';
        case PaymentTypeIds.merrcoDataCandy:
            return 'Merrco gift card';
        case PaymentTypeIds.global:
            return 'Global';
        case PaymentTypeIds.moneris:
            return 'Moneris';
        case PaymentTypeIds.etransfer:
            return 'E-Transfer';
        case PaymentTypeIds.online:
            return 'Online';
        case PaymentTypeIds.birchmount:
            return 'Birchmount gift card';
        case PaymentTypeIds.worldpay:
            return 'Worldpay';
        case PaymentTypeIds.loyalty:
            return 'Loyalty';
        case PaymentTypeIds.blazepay:
            return 'BLAZEPAY';
        default:
            return '';
    }
};
var TransactionContract = /** @class */ (function () {
    function TransactionContract(transaction) {
        var _this = this;
        this.setPaymentTypeId = function (paymentTypeId) {
            _this.paymentTypeId = paymentTypeId;
        };
        this.setAmount = function (amount) {
            _this.amount = amount;
        };
        this.setTerminalInvoiceId = function (terminalInvoiceId) {
            _this.terminalInvoiceId = terminalInvoiceId;
        };
        this.id = transaction.id;
        this.paymentId = transaction.paymentId;
        this.amount = transaction.amount;
        this.status = transaction.status;
        this.completeDate = transaction.completeDate;
        this.paymentTypeId = transaction.paymentTypeId;
        this.terminalInvoiceId = transaction.terminalInvoiceId;
        this.metadata = transaction.metadata;
    }
    __decorate([
        mobx_1.observable
    ], TransactionContract.prototype, "amount", void 0);
    __decorate([
        mobx_1.observable
    ], TransactionContract.prototype, "paymentTypeId", void 0);
    __decorate([
        mobx_1.observable
    ], TransactionContract.prototype, "terminalInvoiceId", void 0);
    __decorate([
        mobx_1.action
    ], TransactionContract.prototype, "setPaymentTypeId", void 0);
    __decorate([
        mobx_1.action
    ], TransactionContract.prototype, "setAmount", void 0);
    __decorate([
        mobx_1.action
    ], TransactionContract.prototype, "setTerminalInvoiceId", void 0);
    return TransactionContract;
}());
exports.TransactionContract = TransactionContract;
var TerminalPaymentTypeIds = [
    PaymentTypeIds.moneris,
    PaymentTypeIds.global,
    PaymentTypeIds.merrco,
    PaymentTypeIds.merrcoDataCandy,
    PaymentTypeIds.birchmount,
    PaymentTypeIds.worldpay,
    PaymentTypeIds.blazepay,
];
exports.GiftCardPaymentTypeIds = [
    PaymentTypeIds.merrcoDataCandy,
    PaymentTypeIds.birchmount,
];
function isTerminalTransaction(paymentTypeId) {
    return TerminalPaymentTypeIds.includes(paymentTypeId);
}
exports.isTerminalTransaction = isTerminalTransaction;
function containsTerminalTransaction(transactions) {
    return transactions.some(function (transaction) { return isTerminalTransaction(transaction.paymentTypeId); });
}
exports.containsTerminalTransaction = containsTerminalTransaction;
var CreateTransaction = /** @class */ (function () {
    function CreateTransaction(paymentTypeId) {
        var _this = this;
        this.amount = 0;
        this.status = TransactionStatus.PENDING;
        this.completeDate = null;
        this.terminalInvoiceId = null;
        /**
         * This property is used to populate the terminalInvoiceId that is required to be sent for terminal refund transactions
         *
         * @type {(string | null)}
         * @memberof CreateTransaction
         */
        this.refundTerminalInvoiceId = null;
        this.metadata = null;
        this.referenceNumber = null;
        this.idempotencyKey = null;
        this.setReferenceNumberFromMetaData = function (metadata) {
            if (metadata === null || !metadata.trim()) {
                return _this.referenceNumber = null;
            }
            // Legacy
            var referenceNumber = (_this.extractValueFromMetadata(metadata, 'referenceNumber') || '').trim();
            if (!referenceNumber) {
                var transactionConfirmationNumber = (_this.extractValueFromMetadata(metadata, 'transactionConfirmationNumber') || '').trim();
                if (transactionConfirmationNumber) {
                    referenceNumber = transactionConfirmationNumber;
                }
            }
            _this.referenceNumber = referenceNumber;
        };
        this.setIdempotencyKey = function (idempotencyKey) {
            _this.idempotencyKey = idempotencyKey;
        };
        this.extractValueFromMetadata = function (metadata, key) {
            if (metadata === null || !metadata.trim()) {
                return undefined;
            }
            var parsedMetadata = JSON.parse(metadata);
            return parsedMetadata[key];
        };
        this.setPaymentTypeId(paymentTypeId);
        if (!isTerminalTransaction(paymentTypeId)) {
            this.setStatus(TransactionStatus.COMPLETED);
        }
    }
    CreateTransaction.prototype.setAmount = function (amount) {
        this.amount = typeof amount === 'number' ? amount || 0 : 0;
    };
    CreateTransaction.prototype.setPaymentTypeId = function (paymentTypeId) {
        this.paymentTypeId = paymentTypeId;
    };
    CreateTransaction.prototype.setStatus = function (status) {
        this.status = status;
    };
    CreateTransaction.prototype.setCompleteDate = function (completeDate) {
        this.completeDate = completeDate;
    };
    CreateTransaction.prototype.setTerminalInvoiceId = function (terminalInvoiceId) {
        this.terminalInvoiceId = terminalInvoiceId;
    };
    CreateTransaction.prototype.setRefundTerminalInvoiceId = function (refundTerminalInvoiceId) {
        this.refundTerminalInvoiceId = refundTerminalInvoiceId;
    };
    CreateTransaction.prototype.setMetadata = function (metadata) {
        this.metadata = metadata;
    };
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "amount", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "completeDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "paymentTypeId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "terminalInvoiceId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "refundTerminalInvoiceId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "metadata", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "referenceNumber", void 0);
    __decorate([
        mobx_1.observable
    ], CreateTransaction.prototype, "idempotencyKey", void 0);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setAmount", null);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setPaymentTypeId", null);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setStatus", null);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setCompleteDate", null);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setTerminalInvoiceId", null);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setRefundTerminalInvoiceId", null);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setMetadata", null);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setReferenceNumberFromMetaData", void 0);
    __decorate([
        mobx_1.action
    ], CreateTransaction.prototype, "setIdempotencyKey", void 0);
    return CreateTransaction;
}());
exports.CreateTransaction = CreateTransaction;
var CreateGiftCardTransaction = /** @class */ (function (_super) {
    __extends(CreateGiftCardTransaction, _super);
    function CreateGiftCardTransaction(paymentTypeId) {
        var _this = _super.call(this, paymentTypeId) || this;
        _this.cardNumber = null;
        _this.transactionId = null;
        _this.isBalanceChecked = false;
        _this.updateGiftCardStatus = function (redeemableAmount, isBalanceChecked, metadata) {
            _this.setRedeemableAmount(redeemableAmount);
            _this.setBalanceChecked(isBalanceChecked);
            _this.setCardNumberFromMetaData(metadata);
        };
        _this.setRedeemableAmount = function (redeemableAmount) {
            _this.redeemableAmount = redeemableAmount;
        };
        _this.setBalanceChecked = function (isBalanceChecked) {
            _this.isBalanceChecked = isBalanceChecked;
        };
        _this.setCardNumber = function (cardNumber) {
            _this.cardNumber = cardNumber;
        };
        _this.setCardNumberFromMetaData = function (metadata) {
            if (metadata === null || !metadata.trim()) {
                return _this.setCardNumber(null);
            }
            var cardNumber = _this.extractValueFromMetadata(metadata, 'cardNumber');
            if (!lodash_1.isNil(cardNumber)) {
                _this.setCardNumber(cardNumber.trim());
            }
        };
        _this.setTransactionIdFromMetaData = function (metadata) {
            if (metadata === null || !metadata.trim()) {
                return _this.transactionId = null;
            }
            var transactionId = _this.extractValueFromMetadata(metadata, 'TRANSACTION_ID');
            if (!lodash_1.isNil(transactionId)) {
                return _this.transactionId = parseInt(transactionId, 10);
            }
        };
        _this.setPin = function (pin) {
            _this.pin = pin;
        };
        return _this;
    }
    __decorate([
        mobx_1.observable
    ], CreateGiftCardTransaction.prototype, "redeemableAmount", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardTransaction.prototype, "cardNumber", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardTransaction.prototype, "transactionId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardTransaction.prototype, "pin", void 0);
    __decorate([
        mobx_1.observable
    ], CreateGiftCardTransaction.prototype, "isBalanceChecked", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardTransaction.prototype, "updateGiftCardStatus", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardTransaction.prototype, "setRedeemableAmount", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardTransaction.prototype, "setBalanceChecked", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardTransaction.prototype, "setCardNumber", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardTransaction.prototype, "setCardNumberFromMetaData", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardTransaction.prototype, "setTransactionIdFromMetaData", void 0);
    __decorate([
        mobx_1.action
    ], CreateGiftCardTransaction.prototype, "setPin", void 0);
    return CreateGiftCardTransaction;
}(CreateTransaction));
exports.CreateGiftCardTransaction = CreateGiftCardTransaction;
var ICompleteTransactionRequest = /** @class */ (function () {
    function ICompleteTransactionRequest() {
    }
    return ICompleteTransactionRequest;
}());
exports.ICompleteTransactionRequest = ICompleteTransactionRequest;
//# sourceMappingURL=Transaction.js.map